import { create } from 'zustand'
import type { IAuthUser } from '@/shared/types/auth-user'
import type { AppAbility } from '@/shared/lib/casl/permissions'
import { defineAbilitiesFor } from '@/shared/lib/casl/abilities'
import type { IOrganizationTraits } from '@/shared/lib/casl/abilities'
import { getOrganizationTinFromUser } from '@/shared/utils/get-organization-id'
import { readStoredUser } from '@/shared/utils/read-stored-user'

export interface AbilityStore {
  abilities: AppAbility
  user: IAuthUser | null
  /** Traits of the user's organization from the registry (BS-295). */
  organization: IOrganizationTraits
  syncFromUser: (user: IAuthUser | null) => void
  syncOrganization: (organization: IOrganizationTraits) => void
}

export const useAbilityStore = create<AbilityStore>((set, get) => ({
  abilities: defineAbilitiesFor(readStoredUser()),
  user: readStoredUser(),
  organization: {},
  syncFromUser: (user) => {
    // A token refresh keeps the organization; signing in as someone from
    // another one must not inherit its traits.
    const sameOrganization =
      getOrganizationTinFromUser(user) ===
      getOrganizationTinFromUser(get().user)
    const organization = sameOrganization ? get().organization : {}
    set({
      user,
      organization,
      abilities: defineAbilitiesFor(user, organization),
    })
  },
  syncOrganization: (organization) => {
    if (organization.isBloodCenter === get().organization.isBloodCenter) return
    set({
      organization,
      abilities: defineAbilitiesFor(get().user, organization),
    })
  },
}))
